



























































import Vue from 'vue';

export default Vue.extend({

  name: 'ConfirmationDialog',

  components: {
  },

  props: {
    btnText: {
      type: String,
      default:  'Confirm',
    },
    confirmText: {
      type: String,
      default:  'Are you sure?',
    },
    confirmTitle: {
      type: String,
      default:  'Confirm Action',
    },
    btnColour: {
      type: String,
      default:  'white',
    },
    emitData: {
      type: Object,
      default:  null,
    },
    icon: {
      type: String,
      default:  '',
    },
    iconSize: {
      type: String,
      default:  'medium',
    },
    iconColour: {
      type: String,
      default:  '',
    },
    padding: {
      type: String,
      default:  '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    dialogProp: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
  },

  data() {
    return {
      dialog: false,
    };
  },

  created() {
    console.log('[ ButtonWithConfirmation created() ]');
  },

  mounted() {
  },

  watch: {
    dialogProp(newVal, oldVal) {
      this.dialog = newVal;
    },
  },

  computed: {
    


  },

  methods: {

      agree() {
        this.dialog = false;
        if (!this.disabled) {
          this.$emit('agree', this.emitData);
        }
      },

      disagree() {
        this.dialog = false;
        this.$emit('disagree', this.emitData);
      },
    
  },


});

